export default __webpack_public_path__ + "static/media/chart_1@3x.d6e3b377.png";